import { connect } from 'react-redux';
import { Holdings } from '@/components/DeprecatedPortfolio/components/Holdings';
import type { Props } from '@/components/DeprecatedPortfolio/components/Holdings';
import {
  portfolioSelector,
  getPortfolioMutableState,
  getIsPortfolioLinked,
} from '@/components/DeprecatedPortfolio/redux/selectors';
import {
  getAllPortfolioItems,
  showTransactionsModal,
} from '@/components/DeprecatedPortfolio/redux/actions';
import { showDeleteHoldingModal } from '@/components/DeprecatedPortfolio/components/DeleteHoldingModal/redux';
import { get } from 'lodash';
import type { State as Portfolios } from '@/components/DeprecatedPortfolios/redux/reducers/interface';
type StateProps = Omit<
  Props,
  | 'handleRedirectOTPLink'
  | 'handleDelete'
  | 'handleFetchPortfolioItems'
  | 'handleEditTransactions'
  | 'sectionNumber'
  | 'updateProfile'
>;

const mapStateToProps = (state: { portfolios: Portfolios }): StateProps => {
  const portfolio = portfolioSelector(state);
  const isEditable = getPortfolioMutableState(state);
  const isPortfolioLinked = getIsPortfolioLinked(state);

  return {
    currentHoldingCount: get(portfolio, 'currentHoldingCount', null),
    excludedCompanyCount: get(portfolio, 'excludedCompanyCount', 0),
    holdings: get(portfolio, 'holdings', null),
    isEditable,
    isPortfolioLinked,
    isWatchlist: get(portfolio, 'isWatchlist', true),
    portfolioId: get(portfolio, 'id', null),
    portfolioWithNoTransactions: get(
      portfolio,
      'portfolioWithNoTransactions',
      false
    ),
  };
};

type DispatchProps = Pick<
  Props,
  'handleDelete' | 'handleFetchPortfolioItems' | 'handleEditTransactions'
>;
const mapDispatchToProps = (dispatch): DispatchProps => {
  return {
    handleDelete: (data) => {
      dispatch(showDeleteHoldingModal(data));
    },
    handleFetchPortfolioItems: (data, isEditable) => {
      dispatch(getAllPortfolioItems(data, !isEditable));
    },
    handleEditTransactions: (data) => dispatch(showTransactionsModal(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Holdings);
